import script from "./bold-options-toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./bold-options-toggle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__